import { render } from "./BedItemList.vue?vue&type=template&id=4b004244&scoped=true"
import script from "./BedItemList.vue?vue&type=script&lang=js"
export * from "./BedItemList.vue?vue&type=script&lang=js"

import "./BedItemList.vue?vue&type=style&index=0&id=4b004244&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b004244"]])

export default __exports__